import { cn } from "@/lib/utils";
import { ReactNode } from "react";

interface CardProps {
  children: ReactNode;
  className?: string;
  gradient?: boolean;
  hover?: boolean;
  shadow?: "none" | "sm" | "md" | "lg" | "xl";
}

export function Card({
  children,
  className,
  gradient = false,
  hover = false,
  shadow = "md",
}: CardProps) {
  return (
    <div
      className={cn(
        "relative overflow-hidden rounded-xl border border-gray-200 bg-white dark:border-gray-700 dark:bg-gray-800",
        {
          "bg-gradient-to-br from-white to-gray-50 dark:from-gray-800 dark:to-gray-900":
            gradient,
          "transition-all duration-200 hover:border-gray-300 hover:shadow-lg dark:hover:border-gray-600":
            hover,
          "shadow-sm": shadow === "sm",
          "shadow-md": shadow === "md",
          "shadow-lg": shadow === "lg",
          "shadow-xl": shadow === "xl",
        },
        className,
      )}
    >
      {children}
    </div>
  );
}

interface CardHeaderProps {
  children: ReactNode;
  className?: string;
  gradient?: boolean;
}

export function CardHeader({
  children,
  className,
  gradient = false,
}: CardHeaderProps) {
  return (
    <div
      className={cn(
        "px-6 py-4",
        {
          "border-b border-gray-200 bg-gradient-to-r from-blue-50 to-indigo-50 dark:border-gray-700 dark:from-blue-900/20 dark:to-indigo-900/20":
            gradient,
        },
        className,
      )}
    >
      {children}
    </div>
  );
}

interface CardBodyProps {
  children: ReactNode;
  className?: string;
}

export function CardBody({ children, className }: CardBodyProps) {
  return <div className={cn("px-6 py-4", className)}>{children}</div>;
}

interface CardFooterProps {
  children: ReactNode;
  className?: string;
}

export function CardFooter({ children, className }: CardFooterProps) {
  return (
    <div
      className={cn(
        "border-t border-gray-200 bg-gray-50 px-6 py-4 dark:border-gray-700 dark:bg-gray-800/50",
        className,
      )}
    >
      {children}
    </div>
  );
}
